//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import { trace, context, TraceFlags, Span } from '@opentelemetry/api';

import { ClientBase } from './client-base';
import { inject } from 'aurelia-framework';
import { HttpClient, RequestInit } from 'aurelia-fetch-client';

export class Inboxv2ClientBase extends ClientBase {
  getBaseUrl(_defaultUrl: string, _baseUrl: string) {
    return this.apiService.getServiceUrl('inbox-minapi');
  }
}

@inject(String, HttpClient)
export class DocumentsClient extends Inboxv2ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("DocumentsClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5212", baseUrl);
    }

    async parseDocument(companyIdentityId: number, documentId: string): Promise<void> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Documents/{documentId}/ParseDocument", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "documentId": documentId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Documents/{documentId}/ParseDocument";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processParseDocument(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processParseDocument(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Queues one document for parsing. A note in the body is first stored as the customer's note
    for the document's class (see LlmCustomerHintsController), so this parse and
    every later parse of that kind of document read with it.
     * @param model (optional) 
     */
    async parse(companyIdentityId: number, documentId: string, model: ParseDocumentModel | undefined): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Documents/{documentId}/Parse", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "documentId": documentId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Documents/{documentId}/Parse";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processParse(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processParse(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Queues multiple documents for parsing. They are parsed one at a time per customer, in the
    given order.
     */
    async batchParse(companyIdentityId: number, documentIds: string[]): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Documents/BatchParse", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Documents/BatchParse";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(documentIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processBatchParse(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processBatchParse(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Stops parsing for the customer: empties the pending parse queue. A document already being
    parsed keeps running to completion.
     */
    async stopParsing(companyIdentityId: number): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Documents/StopParsing", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Documents/StopParsing";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processStopParsing(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processStopParsing(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * The customer's parse queue saga (null if it has never parsed). CurrentState is "Parsing" while
    a document is in flight, else "Idle". Used by the UI for the initial "is parsing active" state;
    live changes arrive via the DocumentParsingQueueState entity-changed broadcast.
     */
    async parsingQueue(companyIdentityId: number): Promise<DocumentParsingQueueState> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Documents/ParsingQueue", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Documents/ParsingQueue";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processParsingQueue(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processParsingQueue(response: Response): Promise<DocumentParsingQueueState> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentParsingQueueState.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentParsingQueueState>(null as any);
    }

    async createEmptyVoucher(companyIdentityId: number, documentId: string): Promise<void> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Documents/{documentId}/CreateEmptyVoucher", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "documentId": documentId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Documents/{documentId}/CreateEmptyVoucher";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processCreateEmptyVoucher(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processCreateEmptyVoucher(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Creates a document with no file behind it, as a container for manually entered vouchers.
    Parsing is skipped; vouchers are added one by one via CreateEmptyVoucher.
     */
    async createManual(companyIdentityId: number): Promise<string> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Documents/CreateManual", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Documents/CreateManual";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processCreateManual(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processCreateManual(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    async upload(companyIdentityId: number, fileSources: FileSources[] | undefined, files: FileParameter[] | null | undefined): Promise<FileUploadResponseViewModel[]> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Documents/Upload", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Documents/Upload?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (fileSources === null)
            throw new globalThis.Error("The parameter 'fileSources' cannot be null.");
        else if (fileSources !== undefined)
            fileSources && fileSources.forEach(item => { url_ += "fileSources=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processUpload(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processUpload(response: Response): Promise<FileUploadResponseViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileUploadResponseViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileUploadResponseViewModel[]>(null as any);
    }

    async getAll(companyIdentityId: number, favoriteOnly: boolean | undefined): Promise<DocumentStateViewModel[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Documents", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Documents?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (favoriteOnly === null)
            throw new globalThis.Error("The parameter 'favoriteOnly' cannot be null.");
        else if (favoriteOnly !== undefined)
            url_ += "favoriteOnly=" + encodeURIComponent("" + favoriteOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGetAll(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGetAll(response: Response): Promise<DocumentStateViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentStateViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentStateViewModel[]>(null as any);
    }

    async openDocumentIds(companyIdentityId: number, favoriteOnly: boolean | undefined): Promise<string[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Documents/OpenDocumentIds", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Documents/OpenDocumentIds?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (favoriteOnly === null)
            throw new globalThis.Error("The parameter 'favoriteOnly' cannot be null.");
        else if (favoriteOnly !== undefined)
            url_ += "favoriteOnly=" + encodeURIComponent("" + favoriteOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processOpenDocumentIds(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processOpenDocumentIds(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    async get(companyIdentityId: number, id: string): Promise<DocumentState> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Documents/{id}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Documents/{id}";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<DocumentState> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentState.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentState>(null as any);
    }

    async file(companyIdentityId: number, id: string): Promise<FileResponse> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Documents/{id}/File", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Documents/{id}/File";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processFile(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    async favorite(companyIdentityId: number, request: FavoriteRequest): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Documents/Favorite", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Documents/Favorite";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processFavorite(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processFavorite(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async archive(companyIdentityId: number, id: string): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Documents/{id}/Archive", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Documents/{id}/Archive";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processArchive(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processArchive(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async remove(companyIdentityId: number, id: string): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Documents/{id}/Remove", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Documents/{id}/Remove";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processRemove(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processRemove(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async reopen(companyIdentityId: number, id: string): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Documents/{id}/Reopen", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Documents/{id}/Reopen";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processReopen(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processReopen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async purge(companyIdentityId: number, id: string): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Documents/{id}/Purge", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Documents/{id}/Purge";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPurge(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPurge(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async sftpgo(request: SftpgoFileUploadedEvent): Promise<void> {
        const span = this.tracer.startSpan("POST /Documents/Sftpgo", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Documents/Sftpgo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processSftpgo(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processSftpgo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Returns the list of file sources that the user can upload files from
     * @param companyIdentityId Company identifier
     */
    async fileSources(companyIdentityId: number): Promise<FileSources[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Documents/FileSources", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Documents/FileSources";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processFileSources(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processFileSources(response: Response): Promise<FileSources[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileSources[]>(null as any);
    }

    async convertDocuments(skip: number | undefined, batchSize: number | undefined, batchesToConvert: number | undefined): Promise<void> {
        const span = this.tracer.startSpan("POST /Documents/ConvertDocuments", {
            attributes: {
                "skip": skip,
                "batchSize": batchSize,
                "batchesToConvert": batchesToConvert,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Documents/ConvertDocuments?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (batchSize === null)
            throw new globalThis.Error("The parameter 'batchSize' cannot be null.");
        else if (batchSize !== undefined)
            url_ += "batchSize=" + encodeURIComponent("" + batchSize) + "&";
        if (batchesToConvert === null)
            throw new globalThis.Error("The parameter 'batchesToConvert' cannot be null.");
        else if (batchesToConvert !== undefined)
            url_ += "batchesToConvert=" + encodeURIComponent("" + batchesToConvert) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processConvertDocuments(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processConvertDocuments(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

@inject(String, HttpClient)
export class LlmCustomerHintsClient extends Inboxv2ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("LlmCustomerHintsClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5212", baseUrl);
    }

    async get(companyIdentityId: number): Promise<LlmCustomerHintViewModel[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/LlmCustomerHints", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/LlmCustomerHints";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<LlmCustomerHintViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LlmCustomerHintViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LlmCustomerHintViewModel[]>(null as any);
    }

    /**
     * Stores the note for the document class, replacing the one before it. An empty note removes it and returns null.
     */
    async put(companyIdentityId: number, documentClass: DocumentClass, model: LlmCustomerHintModel): Promise<LlmCustomerHintViewModel> {
        const span = this.tracer.startSpan("PUT /companies/{companyIdentityId}/LlmCustomerHints/{documentClass}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/LlmCustomerHints/{documentClass}";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (documentClass === undefined || documentClass === null)
            throw new globalThis.Error("The parameter 'documentClass' must be defined.");
        url_ = url_.replace("{documentClass}", encodeURIComponent("" + documentClass));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPut(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPut(response: Response): Promise<LlmCustomerHintViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LlmCustomerHintViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LlmCustomerHintViewModel>(null as any);
    }

    async delete(companyIdentityId: number, documentClass: DocumentClass): Promise<void> {
        const span = this.tracer.startSpan("DELETE /companies/{companyIdentityId}/LlmCustomerHints/{documentClass}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/LlmCustomerHints/{documentClass}";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (documentClass === undefined || documentClass === null)
            throw new globalThis.Error("The parameter 'documentClass' must be defined.");
        url_ = url_.replace("{documentClass}", encodeURIComponent("" + documentClass));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDelete(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

@inject(String, HttpClient)
export class LlmHintsClient extends Inboxv2ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("LlmHintsClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5212", baseUrl);
    }

    /**
     * The document's classified broker, that broker's active hints and the full extraction prompt.
     */
    async document(companyIdentityId: number, documentId: string): Promise<DocumentLlmHintsViewModel> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/LlmHints/{documentId}/Document", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "documentId": documentId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/LlmHints/{documentId}/Document";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDocument(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDocument(response: Response): Promise<DocumentLlmHintsViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentLlmHintsViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentLlmHintsViewModel>(null as any);
    }

    /**
     * Every hint version of the broker, newest first. Empty when the broker has no hints. The broker
    is a query parameter because the v1 OPA policy only matches id segments (digits, GUIDs) in a path.
     * @param broker (optional) 
     */
    async versions(companyIdentityId: number, broker: string | undefined): Promise<LlmHintVersionViewModel[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/LlmHints/Vendors/Versions", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "broker": broker,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/LlmHints/Vendors/Versions?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (broker === null)
            throw new globalThis.Error("The parameter 'broker' cannot be null.");
        else if (broker !== undefined)
            url_ += "broker=" + encodeURIComponent("" + broker) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processVersions(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processVersions(response: Response): Promise<LlmHintVersionViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LlmHintVersionViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LlmHintVersionViewModel[]>(null as any);
    }

    /**
     * Makes the version its broker's active one. Activating an older version is how a revert happens.
     */
    async activate(companyIdentityId: number, versionId: number): Promise<LlmHintVersionViewModel> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/LlmHints/Versions/{versionId}/Activate", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "versionId": versionId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/LlmHints/Versions/{versionId}/Activate";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processActivate(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processActivate(response: Response): Promise<LlmHintVersionViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LlmHintVersionViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LlmHintVersionViewModel>(null as any);
    }

    /**
     * Has the hint editor rewrite the broker's hints from this document and the instruction. The
    result is saved as the broker's new active version straight away; activate its parent to revert.
     */
    async improve(companyIdentityId: number, documentId: string, model: ImproveLlmHintsModel): Promise<ImproveLlmHintsResultViewModel> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/LlmHints/{documentId}/Improve", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "documentId": documentId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/LlmHints/{documentId}/Improve";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processImprove(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processImprove(response: Response): Promise<ImproveLlmHintsResultViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImproveLlmHintsResultViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImproveLlmHintsResultViewModel>(null as any);
    }

    /**
     * Parses the document with the hint version and with the version it was made from and returns
    both readings field by field. Nothing is saved; this shows what the version changes for the document.
     */
    async compare(companyIdentityId: number, documentId: string, versionId: number): Promise<LlmExtractionComparisonViewModel> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/LlmHints/{documentId}/Versions/{versionId}/Compare", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "documentId": documentId,
                "versionId": versionId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/LlmHints/{documentId}/Versions/{versionId}/Compare";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processCompare(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processCompare(response: Response): Promise<LlmExtractionComparisonViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LlmExtractionComparisonViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LlmExtractionComparisonViewModel>(null as any);
    }
}

export class ParseDocumentModel implements IParseDocumentModel {
    /** A note on how to read this kind of document ("the fee is in the second table"). Stored as
the customer's note for the document's class before the parse; omit it to parse with the
note already stored. */
    hint?: string | undefined;

    constructor(data?: IParseDocumentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hint = _data["Hint"];
        }
    }

    static fromJS(data: any): ParseDocumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new ParseDocumentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Hint"] = this.hint;
        return data;
    }
}

export interface IParseDocumentModel {
    /** A note on how to read this kind of document ("the fee is in the second table"). Stored as
the customer's note for the document's class before the parse; omit it to parse with the
note already stored. */
    hint?: string | undefined;
}

export class DocumentParsingQueueState implements IDocumentParsingQueueState {
    correlationId?: string;
    currentState?: DocumentParsingQueueStateMachineStatus;
    companyIdentityId?: number;
    ignoreNotifyState?: boolean;
    customerVatNumber?: string;
    queue?: string[];
    version?: number;

    constructor(data?: IDocumentParsingQueueState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.correlationId = _data["CorrelationId"];
            this.currentState = _data["CurrentState"];
            this.companyIdentityId = _data["CompanyIdentityId"];
            this.ignoreNotifyState = _data["IgnoreNotifyState"];
            this.customerVatNumber = _data["CustomerVatNumber"];
            if (Array.isArray(_data["Queue"])) {
                this.queue = [] as any;
                for (let item of _data["Queue"])
                    this.queue!.push(item);
            }
            this.version = _data["Version"];
        }
    }

    static fromJS(data: any): DocumentParsingQueueState {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentParsingQueueState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CorrelationId"] = this.correlationId;
        data["CurrentState"] = this.currentState;
        data["CompanyIdentityId"] = this.companyIdentityId;
        data["IgnoreNotifyState"] = this.ignoreNotifyState;
        data["CustomerVatNumber"] = this.customerVatNumber;
        if (Array.isArray(this.queue)) {
            data["Queue"] = [];
            for (let item of this.queue)
                data["Queue"].push(item);
        }
        data["Version"] = this.version;
        return data;
    }
}

export interface IDocumentParsingQueueState {
    correlationId?: string;
    currentState?: DocumentParsingQueueStateMachineStatus;
    companyIdentityId?: number;
    ignoreNotifyState?: boolean;
    customerVatNumber?: string;
    queue?: string[];
    version?: number;
}

export class FileUploadResponseViewModel implements IFileUploadResponseViewModel {
    processable?: boolean;
    message?: string;
    index?: number;
    documentId?: string;

    constructor(data?: IFileUploadResponseViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.processable = _data["Processable"];
            this.message = _data["Message"];
            this.index = _data["Index"];
            this.documentId = _data["DocumentId"];
        }
    }

    static fromJS(data: any): FileUploadResponseViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadResponseViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Processable"] = this.processable;
        data["Message"] = this.message;
        data["Index"] = this.index;
        data["DocumentId"] = this.documentId;
        return data;
    }
}

export interface IFileUploadResponseViewModel {
    processable?: boolean;
    message?: string;
    index?: number;
    documentId?: string;
}

export enum FileSources {
    Pdf = 0,
    ParetoPortfolioReport = 1,
    VpsExcelNO = 2,
    SB1Markets = 3,
    ParetoJson = 4,
    VpsExcelEN = 5,
    Insight = 6,
    NordnetTransactions = 7,
    ParetoXml = 8,
    NordnetXml = 9,
    HandelsBankenExcel = 10,
    HandelsBankenJSON = 11,
    OdinJson = 12,
    StorebrandExcel = 13,
    VpsPDf = 14,
    SAndPartners = 15,
    Sb1Forvaltning = 16,
    VpsNO = 21,
    VpsEN = 22,
    Pareto = 23,
    Nordnet = 24,
    HandelsBanken = 25,
    Odin = 26,
    Storebrand = 27,
    Dnb = 28,
    SaxoBank = 29,
    Industrifinans = 30,
    Non = 99,
}

export class DocumentState implements IDocumentState {
    id?: number;
    correlationId?: string;
    currentState?: DocumentStateMachineStatus;
    ignoreNotifyState?: boolean;
    companyIdentityId?: number;
    documentPath?: string;
    documentStorageType?: DocumentStorageType;
    fileType?: FileTypes;
    fromEmail?: string | undefined;
    toEmail?: string | undefined;
    updatedBy?: string;
    createdAt?: string;
    updatedAt?: string;
    favorite?: boolean;
    fileSource?: FileSources;
    locksCount?: number;
    lockingVoucherIds?: string[] | undefined;
    retractsCount?: number;
    documentName?: string;
    parseDocumentRequestId?: string | undefined;
    uploadDocumentRequestId?: string | undefined;
    retrieveDocumentRequestId?: string | undefined;
    vouchersCount?: number;
    createVouchersRequestId?: string | undefined;
    deleteDocumentRequestId?: string | undefined;
    enrichDocumentVouchersRequestId?: string | undefined;
    classifyDocumentRequestId?: string | undefined;
    llmParseDocumentRequestId?: string | undefined;
    documentClass?: DocumentClass;
    classificationConfidence?: number | undefined;
    classificationBroker?: string | undefined;
    version?: number;
    customerVatNumber?: string;

    constructor(data?: IDocumentState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.correlationId = _data["CorrelationId"];
            this.currentState = _data["CurrentState"];
            this.ignoreNotifyState = _data["IgnoreNotifyState"];
            this.companyIdentityId = _data["CompanyIdentityId"];
            this.documentPath = _data["DocumentPath"];
            this.documentStorageType = _data["DocumentStorageType"];
            this.fileType = _data["FileType"];
            this.fromEmail = _data["FromEmail"];
            this.toEmail = _data["ToEmail"];
            this.updatedBy = _data["UpdatedBy"];
            this.createdAt = _data["CreatedAt"];
            this.updatedAt = _data["UpdatedAt"];
            this.favorite = _data["Favorite"];
            this.fileSource = _data["FileSource"];
            this.locksCount = _data["LocksCount"];
            if (Array.isArray(_data["LockingVoucherIds"])) {
                this.lockingVoucherIds = [] as any;
                for (let item of _data["LockingVoucherIds"])
                    this.lockingVoucherIds!.push(item);
            }
            this.retractsCount = _data["RetractsCount"];
            this.documentName = _data["DocumentName"];
            this.parseDocumentRequestId = _data["ParseDocumentRequestId"];
            this.uploadDocumentRequestId = _data["UploadDocumentRequestId"];
            this.retrieveDocumentRequestId = _data["RetrieveDocumentRequestId"];
            this.vouchersCount = _data["VouchersCount"];
            this.createVouchersRequestId = _data["CreateVouchersRequestId"];
            this.deleteDocumentRequestId = _data["DeleteDocumentRequestId"];
            this.enrichDocumentVouchersRequestId = _data["EnrichDocumentVouchersRequestId"];
            this.classifyDocumentRequestId = _data["ClassifyDocumentRequestId"];
            this.llmParseDocumentRequestId = _data["LlmParseDocumentRequestId"];
            this.documentClass = _data["DocumentClass"];
            this.classificationConfidence = _data["ClassificationConfidence"];
            this.classificationBroker = _data["ClassificationBroker"];
            this.version = _data["Version"];
            this.customerVatNumber = _data["CustomerVatNumber"];
        }
    }

    static fromJS(data: any): DocumentState {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CorrelationId"] = this.correlationId;
        data["CurrentState"] = this.currentState;
        data["IgnoreNotifyState"] = this.ignoreNotifyState;
        data["CompanyIdentityId"] = this.companyIdentityId;
        data["DocumentPath"] = this.documentPath;
        data["DocumentStorageType"] = this.documentStorageType;
        data["FileType"] = this.fileType;
        data["FromEmail"] = this.fromEmail;
        data["ToEmail"] = this.toEmail;
        data["UpdatedBy"] = this.updatedBy;
        data["CreatedAt"] = this.createdAt;
        data["UpdatedAt"] = this.updatedAt;
        data["Favorite"] = this.favorite;
        data["FileSource"] = this.fileSource;
        data["LocksCount"] = this.locksCount;
        if (Array.isArray(this.lockingVoucherIds)) {
            data["LockingVoucherIds"] = [];
            for (let item of this.lockingVoucherIds)
                data["LockingVoucherIds"].push(item);
        }
        data["RetractsCount"] = this.retractsCount;
        data["DocumentName"] = this.documentName;
        data["ParseDocumentRequestId"] = this.parseDocumentRequestId;
        data["UploadDocumentRequestId"] = this.uploadDocumentRequestId;
        data["RetrieveDocumentRequestId"] = this.retrieveDocumentRequestId;
        data["VouchersCount"] = this.vouchersCount;
        data["CreateVouchersRequestId"] = this.createVouchersRequestId;
        data["DeleteDocumentRequestId"] = this.deleteDocumentRequestId;
        data["EnrichDocumentVouchersRequestId"] = this.enrichDocumentVouchersRequestId;
        data["ClassifyDocumentRequestId"] = this.classifyDocumentRequestId;
        data["LlmParseDocumentRequestId"] = this.llmParseDocumentRequestId;
        data["DocumentClass"] = this.documentClass;
        data["ClassificationConfidence"] = this.classificationConfidence;
        data["ClassificationBroker"] = this.classificationBroker;
        data["Version"] = this.version;
        data["CustomerVatNumber"] = this.customerVatNumber;
        return data;
    }
}

export interface IDocumentState {
    id?: number;
    correlationId?: string;
    currentState?: DocumentStateMachineStatus;
    ignoreNotifyState?: boolean;
    companyIdentityId?: number;
    documentPath?: string;
    documentStorageType?: DocumentStorageType;
    fileType?: FileTypes;
    fromEmail?: string | undefined;
    toEmail?: string | undefined;
    updatedBy?: string;
    createdAt?: string;
    updatedAt?: string;
    favorite?: boolean;
    fileSource?: FileSources;
    locksCount?: number;
    lockingVoucherIds?: string[] | undefined;
    retractsCount?: number;
    documentName?: string;
    parseDocumentRequestId?: string | undefined;
    uploadDocumentRequestId?: string | undefined;
    retrieveDocumentRequestId?: string | undefined;
    vouchersCount?: number;
    createVouchersRequestId?: string | undefined;
    deleteDocumentRequestId?: string | undefined;
    enrichDocumentVouchersRequestId?: string | undefined;
    classifyDocumentRequestId?: string | undefined;
    llmParseDocumentRequestId?: string | undefined;
    documentClass?: DocumentClass;
    classificationConfidence?: number | undefined;
    classificationBroker?: string | undefined;
    version?: number;
    customerVatNumber?: string;
}

/** Represents the state of a document. For grid display purposes. */
export class DocumentStateViewModel extends DocumentState implements IDocumentStateViewModel {
    /** The document's VouchersCount. */
    vouchersCount?: number | undefined;

    constructor(data?: IDocumentStateViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.vouchersCount = _data["VouchersCount"];
        }
    }

    static override fromJS(data: any): DocumentStateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentStateViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["VouchersCount"] = this.vouchersCount;
        super.toJSON(data);
        return data;
    }
}

/** Represents the state of a document. For grid display purposes. */
export interface IDocumentStateViewModel extends IDocumentState {
    /** The document's VouchersCount. */
    vouchersCount?: number | undefined;
}

export enum DocumentStorageType {
    InsightDb = 1,
    AzureBlob = 2,
    ScwBlob = 3,
    NotSet = -1,
}

export enum FileTypes {
    Voucher = 1,
    MultiLineVoucher = 2,
    MultiLineImportFile = 3,
    Report = 4,
}

export enum DocumentClass {
    Unknown = 0,
    TradeConfirmation = 1,
    DividendNotice = 2,
    WithholdingTaxNotice = 3,
    AccountStatement = 4,
    TabularExport = 5,
    Other = 99,
}

export class FavoriteRequest implements IFavoriteRequest {
    ids?: string[];

    constructor(data?: IFavoriteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Ids"])) {
                this.ids = [] as any;
                for (let item of _data["Ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): FavoriteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FavoriteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["Ids"] = [];
            for (let item of this.ids)
                data["Ids"].push(item);
        }
        return data;
    }
}

export interface IFavoriteRequest {
    ids?: string[];
}

export class SftpgoFileUploadedEvent implements ISftpgoFileUploadedEvent {
    event?: string;
    username?: string;
    fsPath?: string;
    fsTargetPath?: string;
    virtualPath?: string;
    virtualTargetPath?: string;

    constructor(data?: ISftpgoFileUploadedEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.event = _data["Event"];
            this.username = _data["Username"];
            this.fsPath = _data["FsPath"];
            this.fsTargetPath = _data["FsTargetPath"];
            this.virtualPath = _data["VirtualPath"];
            this.virtualTargetPath = _data["VirtualTargetPath"];
        }
    }

    static fromJS(data: any): SftpgoFileUploadedEvent {
        data = typeof data === 'object' ? data : {};
        let result = new SftpgoFileUploadedEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Event"] = this.event;
        data["Username"] = this.username;
        data["FsPath"] = this.fsPath;
        data["FsTargetPath"] = this.fsTargetPath;
        data["VirtualPath"] = this.virtualPath;
        data["VirtualTargetPath"] = this.virtualTargetPath;
        return data;
    }
}

export interface ISftpgoFileUploadedEvent {
    event?: string;
    username?: string;
    fsPath?: string;
    fsTargetPath?: string;
    virtualPath?: string;
    virtualTargetPath?: string;
}

/** The customer's note for one document class. */
export class LlmCustomerHintViewModel implements ILlmCustomerHintViewModel {
    documentClass?: DocumentClass;
    hint?: string;
    updatedBy?: string;
    updated?: string;

    constructor(data?: ILlmCustomerHintViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentClass = _data["DocumentClass"];
            this.hint = _data["Hint"];
            this.updatedBy = _data["UpdatedBy"];
            this.updated = _data["Updated"];
        }
    }

    static fromJS(data: any): LlmCustomerHintViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LlmCustomerHintViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DocumentClass"] = this.documentClass;
        data["Hint"] = this.hint;
        data["UpdatedBy"] = this.updatedBy;
        data["Updated"] = this.updated;
        return data;
    }
}

/** The customer's note for one document class. */
export interface ILlmCustomerHintViewModel {
    documentClass?: DocumentClass;
    hint?: string;
    updatedBy?: string;
    updated?: string;
}

export class LlmCustomerHintModel implements ILlmCustomerHintModel {
    /** The note for the document class; empty removes it. */
    hint?: string | undefined;

    constructor(data?: ILlmCustomerHintModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hint = _data["Hint"];
        }
    }

    static fromJS(data: any): LlmCustomerHintModel {
        data = typeof data === 'object' ? data : {};
        let result = new LlmCustomerHintModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Hint"] = this.hint;
        return data;
    }
}

export interface ILlmCustomerHintModel {
    /** The note for the document class; empty removes it. */
    hint?: string | undefined;
}

/** What the extractor is told about one document: its broker's active hints and the full prompt. */
export class DocumentLlmHintsViewModel implements IDocumentLlmHintsViewModel {
    documentId?: string;
    fileName?: string | undefined;
    documentClass?: string | undefined;
    /** The broker the classifier named for the document. */
    classifiedBroker?: string | undefined;
    /** The hint vendor matching the classified broker, else the classified broker itself. */
    broker?: string | undefined;
    /** The rules every document is extracted with, whatever its issuer. */
    sharedRules?: string;
    /** The system prompt the extractor uses for this broker today. */
    systemPrompt?: string;
    activeVersion?: LlmHintVersionViewModel | undefined;
    /** Every broker that has hints. */
    brokers?: string[];

    constructor(data?: IDocumentLlmHintsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["DocumentId"];
            this.fileName = _data["FileName"];
            this.documentClass = _data["DocumentClass"];
            this.classifiedBroker = _data["ClassifiedBroker"];
            this.broker = _data["Broker"];
            this.sharedRules = _data["SharedRules"];
            this.systemPrompt = _data["SystemPrompt"];
            this.activeVersion = _data["ActiveVersion"] ? LlmHintVersionViewModel.fromJS(_data["ActiveVersion"]) : undefined as any;
            if (Array.isArray(_data["Brokers"])) {
                this.brokers = [] as any;
                for (let item of _data["Brokers"])
                    this.brokers!.push(item);
            }
        }
    }

    static fromJS(data: any): DocumentLlmHintsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentLlmHintsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DocumentId"] = this.documentId;
        data["FileName"] = this.fileName;
        data["DocumentClass"] = this.documentClass;
        data["ClassifiedBroker"] = this.classifiedBroker;
        data["Broker"] = this.broker;
        data["SharedRules"] = this.sharedRules;
        data["SystemPrompt"] = this.systemPrompt;
        data["ActiveVersion"] = this.activeVersion ? this.activeVersion.toJSON() : undefined as any;
        if (Array.isArray(this.brokers)) {
            data["Brokers"] = [];
            for (let item of this.brokers)
                data["Brokers"].push(item);
        }
        return data;
    }
}

/** What the extractor is told about one document: its broker's active hints and the full prompt. */
export interface IDocumentLlmHintsViewModel {
    documentId?: string;
    fileName?: string | undefined;
    documentClass?: string | undefined;
    /** The broker the classifier named for the document. */
    classifiedBroker?: string | undefined;
    /** The hint vendor matching the classified broker, else the classified broker itself. */
    broker?: string | undefined;
    /** The rules every document is extracted with, whatever its issuer. */
    sharedRules?: string;
    /** The system prompt the extractor uses for this broker today. */
    systemPrompt?: string;
    activeVersion?: LlmHintVersionViewModel | undefined;
    /** Every broker that has hints. */
    brokers?: string[];
}

/** One immutable snapshot of a broker's extraction hints. */
export class LlmHintVersionViewModel implements ILlmHintVersionViewModel {
    id?: number;
    versionNumber?: number;
    source?: LlmHintVersionSource;
    /** Whether this is the version the extractor prompts with now. */
    isActive?: boolean;
    /** The version the hint editor started from; activating it reverts this one. */
    parentVersionId?: number | undefined;
    instruction?: string | undefined;
    changeSummary?: string | undefined;
    createdBy?: string | undefined;
    created?: string;
    /** The hints in prompt order. */
    hints?: string[];

    constructor(data?: ILlmHintVersionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.versionNumber = _data["VersionNumber"];
            this.source = _data["Source"];
            this.isActive = _data["IsActive"];
            this.parentVersionId = _data["ParentVersionId"];
            this.instruction = _data["Instruction"];
            this.changeSummary = _data["ChangeSummary"];
            this.createdBy = _data["CreatedBy"];
            this.created = _data["Created"];
            if (Array.isArray(_data["Hints"])) {
                this.hints = [] as any;
                for (let item of _data["Hints"])
                    this.hints!.push(item);
            }
        }
    }

    static fromJS(data: any): LlmHintVersionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LlmHintVersionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["VersionNumber"] = this.versionNumber;
        data["Source"] = this.source;
        data["IsActive"] = this.isActive;
        data["ParentVersionId"] = this.parentVersionId;
        data["Instruction"] = this.instruction;
        data["ChangeSummary"] = this.changeSummary;
        data["CreatedBy"] = this.createdBy;
        data["Created"] = this.created;
        if (Array.isArray(this.hints)) {
            data["Hints"] = [];
            for (let item of this.hints)
                data["Hints"].push(item);
        }
        return data;
    }
}

/** One immutable snapshot of a broker's extraction hints. */
export interface ILlmHintVersionViewModel {
    id?: number;
    versionNumber?: number;
    source?: LlmHintVersionSource;
    /** Whether this is the version the extractor prompts with now. */
    isActive?: boolean;
    /** The version the hint editor started from; activating it reverts this one. */
    parentVersionId?: number | undefined;
    instruction?: string | undefined;
    changeSummary?: string | undefined;
    createdBy?: string | undefined;
    created?: string;
    /** The hints in prompt order. */
    hints?: string[];
}

export enum LlmHintVersionSource {
    Seed = 0,
    Ai = 1,
    Manual = 2,
}

/** The hint version the hint editor produced, already active, and the hints it replaced. */
export class ImproveLlmHintsResultViewModel implements IImproveLlmHintsResultViewModel {
    /** The canonical broker the version was saved under; its history is listed under this name. */
    broker?: string;
    version?: LlmHintVersionViewModel;
    previousHints?: string[];
    /** The hint editor's explanation of what it changed. */
    changeSummary?: string | undefined;

    constructor(data?: IImproveLlmHintsResultViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.broker = _data["Broker"];
            this.version = _data["Version"] ? LlmHintVersionViewModel.fromJS(_data["Version"]) : undefined as any;
            if (Array.isArray(_data["PreviousHints"])) {
                this.previousHints = [] as any;
                for (let item of _data["PreviousHints"])
                    this.previousHints!.push(item);
            }
            this.changeSummary = _data["ChangeSummary"];
        }
    }

    static fromJS(data: any): ImproveLlmHintsResultViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImproveLlmHintsResultViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Broker"] = this.broker;
        data["Version"] = this.version ? this.version.toJSON() : undefined as any;
        if (Array.isArray(this.previousHints)) {
            data["PreviousHints"] = [];
            for (let item of this.previousHints)
                data["PreviousHints"].push(item);
        }
        data["ChangeSummary"] = this.changeSummary;
        return data;
    }
}

/** The hint version the hint editor produced, already active, and the hints it replaced. */
export interface IImproveLlmHintsResultViewModel {
    /** The canonical broker the version was saved under; its history is listed under this name. */
    broker?: string;
    version?: LlmHintVersionViewModel;
    previousHints?: string[];
    /** The hint editor's explanation of what it changed. */
    changeSummary?: string | undefined;
}

export class ImproveLlmHintsModel implements IImproveLlmHintsModel {
    /** The broker whose hints are rewritten. */
    broker!: string;
    /** What the extractor should read differently in this document. */
    instruction!: string;

    constructor(data?: IImproveLlmHintsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.broker = _data["Broker"];
            this.instruction = _data["Instruction"];
        }
    }

    static fromJS(data: any): ImproveLlmHintsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImproveLlmHintsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Broker"] = this.broker;
        data["Instruction"] = this.instruction;
        return data;
    }
}

export interface IImproveLlmHintsModel {
    /** The broker whose hints are rewritten. */
    broker: string;
    /** What the extractor should read differently in this document. */
    instruction: string;
}

/** What the extractor reads from a document with a hint version beside what it reads with the version before it. */
export class LlmExtractionComparisonViewModel implements ILlmExtractionComparisonViewModel {
    versionId?: number;
    versionNumber?: number;
    /** The version the prior reading used; null when that was the shipped hints. */
    priorVersionId?: number | undefined;
    priorVersionNumber?: number | undefined;
    fields?: LlmExtractionFieldViewModel[];

    constructor(data?: ILlmExtractionComparisonViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versionId = _data["VersionId"];
            this.versionNumber = _data["VersionNumber"];
            this.priorVersionId = _data["PriorVersionId"];
            this.priorVersionNumber = _data["PriorVersionNumber"];
            if (Array.isArray(_data["Fields"])) {
                this.fields = [] as any;
                for (let item of _data["Fields"])
                    this.fields!.push(LlmExtractionFieldViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LlmExtractionComparisonViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LlmExtractionComparisonViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["VersionId"] = this.versionId;
        data["VersionNumber"] = this.versionNumber;
        data["PriorVersionId"] = this.priorVersionId;
        data["PriorVersionNumber"] = this.priorVersionNumber;
        if (Array.isArray(this.fields)) {
            data["Fields"] = [];
            for (let item of this.fields)
                data["Fields"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** What the extractor reads from a document with a hint version beside what it reads with the version before it. */
export interface ILlmExtractionComparisonViewModel {
    versionId?: number;
    versionNumber?: number;
    /** The version the prior reading used; null when that was the shipped hints. */
    priorVersionId?: number | undefined;
    priorVersionNumber?: number | undefined;
    fields?: LlmExtractionFieldViewModel[];
}

/** One field of the extraction, e.g. "trade_date" or "items[0].isin". */
export class LlmExtractionFieldViewModel implements ILlmExtractionFieldViewModel {
    field?: string;
    /** The value read with the previous hints. */
    prior?: string | undefined;
    /** The value read with the hint version. */
    updated?: string | undefined;
    changed?: boolean;

    constructor(data?: ILlmExtractionFieldViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["Field"];
            this.prior = _data["Prior"];
            this.updated = _data["Updated"];
            this.changed = _data["Changed"];
        }
    }

    static fromJS(data: any): LlmExtractionFieldViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LlmExtractionFieldViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Field"] = this.field;
        data["Prior"] = this.prior;
        data["Updated"] = this.updated;
        data["Changed"] = this.changed;
        return data;
    }
}

/** One field of the extraction, e.g. "trade_date" or "items[0].isin". */
export interface ILlmExtractionFieldViewModel {
    field?: string;
    /** The value read with the previous hints. */
    prior?: string | undefined;
    /** The value read with the hint version. */
    updated?: string | undefined;
    changed?: boolean;
}

/** Available statuses:<br/>0: ParsingSkipped<br/>1: Classifying<br/>2: LlmParsing<br/>3: Ready<br/>4: Reopened<br/>5: Created<br/>6: Parsing<br/>7: Parsed<br/>8: ParsingFaulted<br/>9: ParsingHalted<br/>10: CreatingVouchers<br/>11: Enriching<br/>12: EnrichingFaulted<br/>13: CreatingVouchersFaulted<br/>14: Processing<br/>15: Processed<br/>16: Archived<br/>17: Removed<br/>18: Initial<br/>19: Final */
export enum DocumentStateMachineStatus {
    ParsingSkipped = "ParsingSkipped",
    Classifying = "Classifying",
    LlmParsing = "LlmParsing",
    Ready = "Ready",
    Reopened = "Reopened",
    Created = "Created",
    Parsing = "Parsing",
    Parsed = "Parsed",
    ParsingFaulted = "ParsingFaulted",
    ParsingHalted = "ParsingHalted",
    CreatingVouchers = "CreatingVouchers",
    Enriching = "Enriching",
    EnrichingFaulted = "EnrichingFaulted",
    CreatingVouchersFaulted = "CreatingVouchersFaulted",
    Processing = "Processing",
    Processed = "Processed",
    Archived = "Archived",
    Removed = "Removed",
    Initial = "Initial",
    Final = "Final",
}

/** Available statuses:<br/>0: Parsing<br/>1: Idle<br/>2: Initial<br/>3: Final */
export enum DocumentParsingQueueStateMachineStatus {
    Parsing = "Parsing",
    Idle = "Idle",
    Initial = "Initial",
    Final = "Final",
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function getTraceParent(span: Span) {
  return `00-${span.spanContext().traceId}-${span.spanContext().spanId}-0${Number(span.spanContext().traceFlags || TraceFlags.NONE).toString(16)}`;
}